<template>
	<div>
		<page-title-bar class="pb-1">
			<template slot="actions">
				<menu-downloads v-if="permisos.descargar"></menu-downloads>
			</template>
		</page-title-bar>
		<v-container fluid pt-0>
			<v-layout row wrap border-rad-sm overflow-hidden>
				<app-card
						colClasses="xs12"
						customClasses="mb-0"
						:fullScreen="true"
						:reloadable="true"
						:closeable="true"
						:fullBlock="true"
						:footer="false"
				>
					<data-table
							ref="tableDireccionamientos"
							v-model="dataTable"
							@resetOption="item => resetOptions(item)"
							@programar="item => openDialogProgramar(item)"
              @descargarSoporte="item => descargarSoporte(item)"
					></data-table>
					<app-section-loader :status="processingTable"></app-section-loader>
				</app-card>
			</v-layout>
		</v-container>
		<confirmation-dialog
				ref="dialogConfirmProgramacion"
				heading="¿Seguro de continuar?"
				:message="`¿Está seguro de continuar con la programación del direccionamiento &nbsp; <strong>${selectedDireccionamiento ? selectedDireccionamiento.IDDireccionamiento : ''}?`"
				@onConfirm="programaDireccionamientoDirecto({sedeId: sedes ? sedes[0].id : null})"
		>
		</confirmation-dialog>
		<programa-direccionamiento-dialog
				ref="dialogProgramaDireccionamiento"
				:heading="`Programación del direccionamiento &nbsp; <strong>${selectedDireccionamiento ? selectedDireccionamiento.IDDireccionamiento : ''}</strong>`"
				@onConfirm="result => programaDireccionamiento(result)"
		>
		</programa-direccionamiento-dialog>
		<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="processingTable = false"></detail-technologi-dialog>
	</div>
</template>

<script>
	var $this = null
    export default {
        components: {
            ProgramaDireccionamientoDialog: () => import('@/components/Direccionamientos/ProgramaDireccionamientoDialog'),
            MenuDownloads: () => import('@/components/Direccionamientos/MenuDownloads')
		},
        data: () => ({
            processingTable: false,
			selectedDireccionamiento: null,
			dataTable: {
                nameItemState: 'tableDireccionamientos',
                route: 'direccionamientos',
                makeHeaders: [
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: false,
                        visibleColumn: false,
                        value: 'id'
                    },
                    {
                        text: 'Direccionamiento',
                        align: 'left',
                        sortable: false,
                        value: 'IDDireccionamiento',
						component: {
							render: function (createElement) {
								return createElement(
									`div`,
									{
										domProps: {
											innerHTML: `
											<v-list-tile>
												<v-list-tile-content style="display: grid !important;">
													<v-list-tile-title class="body-2">Id: ${this.value.IDDireccionamiento}</v-list-tile-title>
													<v-list-tile-sub-title class="caption">Fecha: ${this.value.FecDireccionamiento ? this.moment(this.value.FecDireccionamiento).format('YYYY-MM-DD HH:mm') : ''}</v-list-tile-sub-title>
												</v-list-tile-content>
											</v-list-tile>
										`
										}
									}
								)
							},
							props: ['value']
						}
                    },
                    {
                        text: 'Municipio Ent.',
                        tooltip: 'Municipio de Entrega',
                        align: 'left',
                        sortable: false,
                        value: 'CodMunEnt'
                    },
                    {
                        text: 'Prescripción',
                        align: 'left',
                        sortable: true,
                        value: 'NoPrescripcion'
                    },
                    {
                        text: 'ServTecEntregar',
                        tooltip: 'Servicio o tecnología a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'TipoTec',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `a`,
                                    {
                                        domProps: {
                                            innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecAEntregar}`
                                        },
                                        on: {
                                            click: () => {
                                                $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecAEntregar)
                                            }
                                        }
                                    }
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Cant.',
                        tooltip: 'Cantidad total a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotAEntregar',
                        classData: 'text-xs-center'
                    },
                    {
                        text: 'Max. entrega',
                        tooltip: 'Fecha maxima de entrega',
                        align: 'left',
                        sortable: true,
                        value: 'FecMaxEnt'
                    },
                    {
                        text: 'Paciente',
                        align: 'left',
                        sortable: false,
                        value: 'NoIDPaciente',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.TipoIDPaciente}${this.value.NoIDPaciente}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'EPS',
                        align: 'left',
                        sortable: false,
                        value: 'CodEPS',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `div`,
                                    {
                                        domProps: {
                                            innerHTML: `
												<v-list-tile>
													<v-list-tile-content style="display: grid !important;">
														<v-list-tile-title class="body-2">${this.value.NoIDEPS}</v-list-tile-title>
														<v-list-tile-sub-title class="caption">Código: ${this.value.CodEPS}</v-list-tile-sub-title>
													</v-list-tile-content>
												</v-list-tile>
											`
                                        }
                                    }
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Opciones',
                        align: 'center',
                        sortable: false,
                        actions: true,
                        singlesActions: true,
                        classData: 'text-xs-center'
                    }
                ],
                filters: [
                    {
                        label: 'Fecha maxima de entega',
                        type: 'v-range',
						 params:'filter[FecMaxEntBetween]=',
                        items: {
                            menuDate: false,
                            type: 'date',
                            range: true,
                            itemMin: {
                                label: 'Inicial',
                                vModel: null,
                                clearable: true,
                                value: 'FecMaxEnt'
                            },
                            itemMax: {
                                menuDate: false,
                                label: 'Final',
                                vModel: null,
                                clearable: true,
                                value: 'FecMaxEnt'
                            }
                        }
                    },
                    {
                        label: 'Fecha direccionamiento',
                        type: 'v-range',
                        params:'filter[FecDireccionamientoBetween]=',
                        items: {
                            menuDate: false,
                            type: 'date',
                            range: true,
                            itemMin: {
                                label: 'Inicial',
                                vModel: null,
                                clearable: true,
                                value: 'FecDireccionamiento'
                            },
                            itemMax: {
                                menuDate: false,
                                label: 'Final',
                                vModel: null,
                                clearable: true,
                                value: 'FecDireccionamiento'
                            }
                        }
                    }
				]
            }
		}),
        computed: {
            sedes () {
                return this.$store.state.general.sedes
            },
			permisos () {
                return this.$store.getters.getPermissionModule('direccionamientos')
			}
        },
		created () {
            $this = this
		},
		methods: {
            getDetalleTechnologi (type, code) {
                this.processingTable = true
				this.$refs.dialogInfoTechnologi.getDetail(type, code)
			},
            programaDireccionamientoDirecto (result) {
				this.registraProgramacionDireccionamiento(result, 'dialogConfirmProgramacion')
			},
            programaDireccionamiento (result) {
                this.registraProgramacionDireccionamiento(result, 'dialogProgramaDireccionamiento')
			},
            registraProgramacionDireccionamiento (result, referencia) {
                this.$refs[referencia].loading()
                this.axios.post(`programaciones/${this.selectedDireccionamiento.id}/${result.sedeId}`)
                    .then((response) => {
                        this.$store.commit('snackbar', {color: 'success', message: `Se programó el direccionamiento de forma correcta`})
                        this.$refs.tableDireccionamientos.reloadPage()
                        this.$refs[referencia].close()
                    }).catch(e => {
                    this.$refs[referencia].loading(false)
                    this.$store.commit('snackbar', {color: 'error', message: `al programar el direccionamiento`, error: e})
                })
			},
            openDialogProgramar (item) {
                this.selectedDireccionamiento = item
				if (this.sedes && this.sedes.length) {
                    if (this.sedes.length > 1) {
                        this.$refs.dialogProgramaDireccionamiento.open()
                    } else {
                        this.$refs.dialogConfirmProgramacion.open()
                    }
				} else {
                    this.$store.commit('snackbar', {color: 'error', message: `No hay sedes disponibles para programar direccionamientos`})
				}
            },
      async descargarSoporte (item) {
        item.loading = true
        let archivo = {
          url: `direccionamientos/soporte/${item.id}`
        }
        await this.descargarArchivo(archivo)
        item.loading = false
      },
            resetOptions (item) {
                item.options = []
                if (item.EstDireccionamiento === 1) item.options.push({event: this.permisos.programar ? 'programar' : '', icon: 'ti ti-timer', tooltip: this.permisos.programar ? 'Programar' : 'Sin permisos para programar', color: this.permisos.programar ? 'success' : 'grey', size: 'medium'})
                item.options.push({event: this.generarSoporte ? 'descargarSoporte' : '', icon: 'zmdi zmdi-collection-pdf', tooltip: this.generarSoporte ? 'Descargar Soporte' : 'Sin permisos para descargar el soporte', color: this.generarSoporte ? 'black' : 'grey', size: 'medium'})
                return item
            }
		}
    }
</script>
